/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import useAssetService from 'domain/finance/assets/useAssetService';
import { useAssetUrl, useAssetId } from 'domain/finance/assets/shared/useAssetRouting';
import CreateAssetBreadcrumbs from 'domain/finance/assets/createupdate/Create/Breadcrumbs';
import AssetForm from 'domain/finance/assets/createupdate/AssetForm';

const CreateAssetPage = () => {
  const { create, getValidationSchema, getByIdForCopying } = useAssetService();
  const { getSingleEntityUrl } = useAssetUrl();
  let getDataFunc;
  const id = useAssetId();

  if (id) {
    getDataFunc = () => getByIdForCopying(id);
  }

  return (
    <CreateForm
      submitFormFunc={create}
      getDataFunc={getDataFunc}
      afterSubmit={{
        redirect: ({ inventoryNumber }) => getSingleEntityUrl(inventoryNumber),
        message: 'You are awesome! The Asset has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        customUsefulLifePeriod: {
          timeUnit: 'MONTHS',
        },
      }}
    >
      <CreatePageLayout breadcrumbs={<CreateAssetBreadcrumbs />} title="Create: Asset">
        <AssetForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateAssetPage;
